import { makeImageSrcSelector } from "@client/content/selectors";
import { type ItemContainerProps } from "@client/content/types";
import { connectCustom } from "@client/lib/misc";
import { TargetSelector } from "@client/selectors";
import { type AppState } from "@client/types";
import classnames from "classnames";
import { setSelectedItem } from "../actions";
import { localStateSelector } from "../selectors";
import Component, { type ImageGalleryItemActionProps, type ImageGalleryItemMapProps } from "./component";

const makeMapStateToProps = () => {
  const imageSrcSelector = makeImageSrcSelector(TargetSelector.Entity, "image");

  return (state: AppState, props: ItemContainerProps): ImageGalleryItemMapProps => {
    const localState = localStateSelector(state, { id: props.parentId });

    return {
      ...props,
      className: classnames("thumbnail_item", {
        selected: localState.selectedItemId === props.id
      }),
      imageSrc: imageSrcSelector(state, props)
    };
  };
};

const mapDispatchToProps = (dispatch: any, props: ItemContainerProps): ImageGalleryItemActionProps => ({
  onClick: () => dispatch(setSelectedItem({ id: props.parentId, source: props.source }, props.id))
});

export default connectCustom(makeMapStateToProps, mapDispatchToProps)(Component);
